import { connect } from "react-redux";
import { ResultsComparisonDialysis as Component } from "./ResultsComparisonDialysis";

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    dialysisTable: ownProps.dialysisTable,
    dialysisTablePrediction:
      state.dialysisDragDrop?.predicts[ownProps.predictionId],
    dialysisTableResults: state.dialysisDragDrop?.results[ownProps.id],
    actualResults: state.electronicScale,
    dialysisConcentration: state.dialysisConcentration,
  };
}

function mapDispatchToProps() {
  return {};
}

export const ResultsComparisonDialysis = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
